<mat-form-field [class]="inputClass">
  <mat-label class="with-action">
    <div class="align-h-space-between">
      <span>{{ label }}</span>
      <button type="button" appStopPropagation (click)="openAddItemDialog()" class="btn icon icon-plus link">Add Template</button>
    </div>
  </mat-label>

  <mat-select [disabled]="disabled"
    [errorStateMatcher]="errorStateMatcher"
    [placeholder]="placeholder"
    [compareWith]="compareFn"
    [(ngModel)]="value"
    (selectionChange)="onSelect($event.value)"
    (blur)="onTouched()">

    @if (options) {
      <!-- List mode -->
      <ng-container>
        @if (hasEmptyOption) {
          <mat-option [value]="false">{{emptyOptionLabel}}</mat-option>
        }
        @for (template of options; track template) {
          <mat-option [value]="template">
            {{template.name}}
          </mat-option>
        }
      </ng-container>
      <!-- Empty list -->
      @if (!options.length) {
        <mat-option [value]="false" [disabled]="true">
          {{emptyMessage}}
        </mat-option>
      }
    }
  </mat-select>

  <div matSuffix>
    @if (isLoading) {
      <app-preloader [type]="preloaderTypes.ICON" [size]="20"></app-preloader>
    }
  </div>

  <!-- Show control errors -->
  <mat-error>
    <app-validation-error [errors]="ngControl.errors"></app-validation-error>
  </mat-error>
</mat-form-field>
